var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main card"},[_c('div',{staticClass:"add-line",on:{"click":_vm.addLine}},[_c('img',{attrs:{"src":require("../../../assets/images/dadbanan/plus.svg")}}),_c('div',[_vm._v("اضافه کردن سرفصل")])])])}
var staticRenderFns = []

export { render, staticRenderFns }